module.exports = __webpack_public_path__ + "media/assets/images/face-upload/webcam-51192c886f43843b848292f30fd1f267.png";